import { useEffect, useState } from 'react'
import { AUTO_BET_CONFIG } from 'src/config'
import type { MarbleGame } from 'src/types/domain/Game'
import { getBettingTimeWindow } from 'src/utils/getBettingTimeWindow'
import { getLatestEvent } from 'src/utils/raceUtils'

type Props = Readonly<{
  game: MarbleGame
  isAutoBet: boolean
}>

export default function BetProgressButtonOverlay({ game, isAutoBet }: Props) {
  const currentRace = game.races[0]
  const latestEvent = getLatestEvent(currentRace.raceEvents)
  const raceReadyEvent = currentRace.raceEvents.find((event) => event.eventType === 'race_ready')
  const TOTAL_COUNTDOWN_TIME = isAutoBet ? AUTO_BET_CONFIG.BET_COUNTDOWN : getBettingTimeWindow(game)

  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (
      !raceReadyEvent ||
      !['race_ready', 'race_starting'].includes(latestEvent?.eventType || '')
    ) {
      setProgress(0)
      return
    }

    const startTime = new Date(raceReadyEvent.eventTimestamp).getTime()

    const updateProgress = () => {
      const now = Date.now()
      const elapsed = (now - startTime) / 1000
      const newProgress = Math.min((elapsed / TOTAL_COUNTDOWN_TIME) * 100, 100)
      setProgress(newProgress)
    }

    updateProgress()

    const intervalId = setInterval(updateProgress, 100)

    return () => {
      clearInterval(intervalId)
    }
  }, [TOTAL_COUNTDOWN_TIME, latestEvent?.eventType, raceReadyEvent])

  const progressBarStyles = {
    transform: `scaleX(${progress / 100})`,
    transition: 'transform 100ms linear'
  } as React.CSSProperties

  return <div className="progress-bar" style={progressBarStyles} />
}
